import React, { Component } from 'react'
import classNames from "classnames";

// core components
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Icon from "@material-ui/core/Icon";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import languageSelectorStyle from "assets/jss/prehnit/components/languageSelectorStyle.jsx";

import { withNamespaces } from "react-i18next";

import i18n from 'i18next';
import numbro from 'numbro';

import { Languages as LanguagesFallback } from "config/LanguageList.jsx";

import { API } from "services/api";

class LanguageSelector extends Component {

  constructor(props) {
    super(props)

    this.state = {
      open: false
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSelectLanguage = this.handleSelectLanguage.bind(this);

    this.langs = [];

    API.getLanguages()
    .then (data => {
      if (data && data.length > 0) {
        this.langs = data;

      } else {
        console.warn('Loading Fallback Languages...!');
        this.langs = LanguagesFallback;
      }
    });

  }

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleSelectLanguage(lng) {
    if (lng.code) {
      i18n.changeLanguage(lng.code);
      numbro.setLanguage(lng.code);
      this.setState({
        open: false
      })
    }
  }

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  displayName(code) {
    if (this.langs && this.langs.length > 0 ) {
      let lngs = this.langs.filter(lng => {
        return lng.code === code;
      });
      if (lngs && lngs.length > 0) {
        return lngs[0].abbr;
      }
    } else { //default
      switch (code) {
        case "hr":
          return "HRV";
        case "en":
          return "ENG";
        default:
          return "HRV";
        }
    }
  }

  render() {
    const { open } = this.state;
    const {
      classes,
      buttonText,
      buttonIcon,
      buttonProps,
      dropup,
      caret,
      hoverColor,
      dropPlacement,
      noLiPadding,
      innerDropDown,
      navDropdown
    } = this.props;

    const caretClasses = classNames({
      [classes.caret]: true,
      [classes.caretDropup]: dropup && !open,
      [classes.caretActive]: open && !dropup
    });

    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes[hoverColor + "Hover"]]: true,
      [classes.noLiPadding]: noLiPadding && false,
    });

    const dropDownMenu = (
      <MenuList role="menu" className={classes.menuList}>
        {this.langs.map((prop, key) => {
          return (
            <MenuItem
              key={key}
              onClick={() => this.handleSelectLanguage(prop)}
              className={dropdownItem}
            >
              <Icon className={classes.dropdownIcons}>chat</Icon>
              {prop.title}
            </MenuItem>
          );
        })}
      </MenuList>
    );

    return (
      <div className={innerDropDown ? classes.innerManager : classes.manager}>
        <div className={buttonText !== undefined ? "" : classes.target}>
          <Button
            aria-label="Notifications"
            aria-owns={open ? "menu-list" : null}
            aria-haspopup="true"
            buttonRef={node => {
              this.anchorEl = node;
            }}
            {...buttonProps}
            onClick={this.handleClick}
          >
            {buttonIcon !== undefined ? (
              <this.props.buttonIcon className={classes.buttonIcon} />
            ) : null}
            {this.displayName(this.props.lng)}
            {caret ? <b className={caretClasses} /> : null}
          </Button>
        </div>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          transition
          disablePortal
          placement={dropPlacement}
          className={classNames({
            [classes.popperClose]: !open,
            [classes.pooperResponsive]: true,
            [classes.pooperNav]: open && navDropdown
          })}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              in={open}
              id="menu-list"
              style={
                dropup
                  ? { transformOrigin: "0 100% 0" }
                  : { transformOrigin: "0 0 0" }
              }
            >
              <Paper className={classes.dropdown}>
                {innerDropDown ? (
                  dropDownMenu
                  ) : (
                  <ClickAwayListener onClickAway={this.handleClose} ref="cacat">
                    {dropDownMenu}
                  </ClickAwayListener>
                )}
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

LanguageSelector.defaultProps = {
  caret: true,
  buttonText: "---",
}

export default withNamespaces()(withStyles(languageSelectorStyle)(LanguageSelector));